import { createContext } from 'react';
import type { ControlledDateTimePickerContextT } from './config/useControlledDateTimePicker.js';

const defaultContext = {} as ControlledDateTimePickerContextT;

/** Context for cross component communication */
export const ControlledDateTimePickerContext = createContext<ControlledDateTimePickerContextT>(defaultContext);

export default ControlledDateTimePickerContext;
